import axiosInstance, { endpoints } from 'src/utils/axios';

export const matchApiService = {
  // Get all matches for a session
  async getSessionMatches(sessionId, params = {}) {
    try {
      const response = await axiosInstance.get(`/admin/matches/session/${sessionId}`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching session matches:', error);
      throw error;
    }
  },

  // Get match details
  async getMatchById(matchId) {
    try {
      const response = await axiosInstance.get(`/admin/matches/${matchId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching match:', error);
      throw error;
    }
  },

  // Update match status
  async updateMatchStatus(matchId, status) {
    try {
      const response = await axiosInstance.patch(`/admin/matches/${matchId}/status`, {
        status,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating match status:', error);
      throw error;
    }
  },

  // Update match score
  async updateMatchScore(matchId, teamId, score) {
    try {
      const response = await axiosInstance.patch(`/admin/matches/${matchId}/score`, {
        team_id: teamId,
        score,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating match score:', error);
      throw error;
    }
  },

  // Set match winner
  async setMatchWinner(matchId, winnerTeamId) {
    try {
      const response = await axiosInstance.patch(`/admin/matches/${matchId}/winner`, {
        winner_team_id: winnerTeamId,
      });
      return response.data;
    } catch (error) {
      console.error('Error setting match winner:', error);
      throw error;
    }
  },

  // Create matchmaking
  async createMatchmaking(sessionId, matchType = 'DOUBLES') {
    try {
      const response = await axiosInstance.post('/admin/matches/matchmaking', {
        session_id: sessionId,
        match_type: matchType,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating matchmaking:', error);
      throw error;
    }
  },

  // Regenerate matches
  async regenerateMatches(sessionId, matchType = 'DOUBLES') {
    try {
      const response = await axiosInstance.post(`/admin/matches/session/${sessionId}/regenerate`, {
        match_type: matchType,
      });
      return response.data;
    } catch (error) {
      console.error('Error regenerating matches:', error);
      throw error;
    }
  },

  // Delete session matches
  async deleteSessionMatches(sessionId) {
    try {
      const response = await axiosInstance.delete(`/admin/matches/session/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting session matches:', error);
      throw error;
    }
  },

  // Create next round
  async createNextRound(sessionId, matchType = 'DOUBLES') {
    try {
      const response = await axiosInstance.post(`/admin/matches/session/${sessionId}/next-round`, {
        match_type: matchType,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating next round:', error);
      throw error;
    }
  },

  // Create a single match manually
  async createSingleMatch(data) {
    try {
      const response = await axiosInstance.post('/admin/matches', data);
      // Response is { status: 'success', data: matchData } or just matchData
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error creating single match:', error);
      throw error;
    }
  },

  // Assign court to a match
  async assignCourtToMatch(matchId, courtId) {
    try {
      const response = await axiosInstance.patch(`/admin/matches/${matchId}/court`, {
        court_id: courtId,
      });
      // Response is { status: 'success', data: matchData } or just matchData
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error assigning court to match:', error);
      throw error;
    }
  },

  // Delete a single match
  async deleteMatch(matchId) {
    try {
      const response = await axiosInstance.delete(`/admin/matches/${matchId}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error deleting match:', error);
      throw error;
    }
  },
};
